export const GUIDED_TOUR_START = 'guided-tour:start'
const PENDING_KEY = 'guided-tour-pending'

export function requestGuidedTour() {
  try {
    sessionStorage.setItem(PENDING_KEY, '1')
  } catch {
    // Ignore storage failures; the event still starts the tour on this page.
  }
  window.dispatchEvent(new Event(GUIDED_TOUR_START))
}

export function consumePendingTourStart() {
  try {
    const pending = sessionStorage.getItem(PENDING_KEY) === '1'
    if (pending) sessionStorage.removeItem(PENDING_KEY)
    return pending
  } catch {
    return false
  }
}

export function isGuidedTourCompleted(uuid: string) {
  try {
    return localStorage.getItem(`guided-tour-completed:${uuid}`) === '1'
  } catch {
    return true
  }
}

export function markGuidedTourCompleted(uuid: string) {
  try {
    localStorage.setItem(`guided-tour-completed:${uuid}`, '1')
  } catch {
    // Storage can be unavailable; the tour still closes.
  }
}
